module.exports = __webpack_public_path__ + "img/faq-null-icon.1c827aa5.png";